import { toast } from 'react-toastify';
export const attachResponseInterceptor = (api) => {
    api.interceptors.response.use((response) => response, async (error) => {
        if (error.name === 'AbortError' || error.name === 'CanceledError' || error.code === 'ERR_CANCELED') {
            return Promise.reject(error);
        }
        const requestUrl = error.config?.url;
        const responseError = {
            message: error.response?.data?.message || error.response?.data?.error || 'An error occurred',
            status: error.response?.status || 500,
            isSuccess: false
        };
        if (responseError.status === 500 && requestUrl !== '/users/userinfo') {
            toast.error(responseError.message);
        }
        else {
        }
        return Promise.reject(responseError);
    });
    return api;
};
